import { useEffect, useRef, useState } from 'react';

import { Input } from '@/components/ui/Input';

/**
 * Поле поиска с задержкой: `onSearch` зовётся через `delay` мс после последней буквы (по умолчанию 300), а не на
 * каждую — в списке учеников запрос к серверу уходил на каждую букву (разбор удобства 28.09). Подсказка — только
 * пропсом: в `components/` кириллица в коде запрещена сторожем `noHardcodedText`.
 */
export function SearchInput({
  value,
  onSearch,
  placeholder,
  delay = 300,
  className,
  ariaLabel,
}: {
  value?: string;
  onSearch: (q: string) => void;
  placeholder?: string;
  delay?: number;
  className?: string;
  ariaLabel?: string;
}) {
  const [text, setText] = useState(value ?? '');
  const first = useRef(true);
  const cb = useRef(onSearch);
  cb.current = onSearch;

  // Внешний сброс (другая вкладка, «очистить фильтры») — поле идёт за значением.
  useEffect(() => {
    setText(value ?? '');
  }, [value]);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const id = setTimeout(() => cb.current(text.trim()), delay);
    return () => clearTimeout(id);
  }, [text, delay]);

  return (
    <Input
      className={className}
      placeholder={placeholder}
      aria-label={ariaLabel ?? placeholder}
      leftIcon={<span className="material-symbols-outlined">search</span>}
      value={text}
      onChange={(e) => setText(e.target.value)}
    />
  );
}
